import React from "react";

const VARIANTS = {
  up: "reveal",
  left: "reveal reveal-left",
  right: "reveal reveal-right",
  scale: "reveal reveal-scale",
};

/** Wrapper de entrada animada. O `useReveal()` do App ativa a classe. */
const Reveal = ({
  as: Tag = "div",
  variant = "up",
  delay = 0,
  blur = true,
  className = "",
  children,
  ...rest
}) => (
  <Tag
    className={`${VARIANTS[variant] || VARIANTS.up} ${
      blur ? "" : "reveal-blur-none"
    } ${className}`}
    data-delay={delay}
    {...rest}
  >
    {children}
  </Tag>
);

export default Reveal;
